var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.editable)?_c('span',[_vm._v(_vm._s(_vm.value))]):_c('flat-pickr',{staticClass:"flat-pickr",attrs:{"placeholder":"Time","value":_vm.value,"step":"0","config":{placeholder: 'Time',
                        enableTime: true,
                        noCalendar: true,
                        altInput: true,
                        altFormat: 'h:i K',
                        dateFormat: 'h:i K',
                        allowInput: true}},on:{"on-change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }